export const DRAFT_ERRORS = {
  LOCATION: 'location',
  UPS: 'ups',
  INVALID_PRODUCTS_QUANTITY: 'noProductsQuantity',
  COUNTRY: 'country'
};